<template>
  <div>
    <w-user-access-common-table active-tab="menuAccessHist" @load-data="loadData" :target-table="targetTable"
      :target-table-data="menuAccessHistData" :total="total"></w-user-access-common-table>
  </div>
</template>

<script>
import UserAccessHistApi from '@/api/settings/user/user-access-hist';
import WUserAccessCommonTable from './components/UserAccessCommonTable';

export default {
  name: 'WMenuAccessHist',
  components: { WUserAccessCommonTable },
  props: {
    activeTab: {
      type: String,
    },
  },
  data() {
    return {
      targetTable: 'menuAccessHist',
      menuAccessHistData: [],
      total: 0,
    };
  },
  methods: {
    loadData(item, tableParams) {
      const params = {
        ...tableParams,
        startDatetime: item ? item[0] : null,
        endDatetime: item ? item[1] : null,
      };
      UserAccessHistApi.getMenuAccessHistList(params).then((response) => {
        if (response.data.success) {
          this.menuAccessHistData = response.data.data;
          this.total = response.data.total;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/UserAndAuthManagement/UserAccessHist/MenuAccessHist.vue